/* eslint-disable */

/**
 * Fonction d'affichage des images
 *
 *
 * @author <span><span class="fw-bold">Nicolas Huber</span><a class="ms-2" href="mailto:dmod-huber.consultant@dgfip.finances.gouv.fr">dmod-huber.consultant@dgfip.finances.gouv.fr</a></span>
 * @since Version 1.0
 * @version 1.2.1
 * @displayName handleImage
 *
 */
export default {
    methods: {
        // ----------------------------------------------------
        // Méthode qui retourne l'url d'une image pour le src :
        // ----------------------------------------------------
        handleImage: function (img) {
            // expression régulière pour tester si img est une url externe :
            const reg = new RegExp('(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})', 'gi');
            if (reg.test(img)) return img;
            // images internes dans le dossier assets :
            return require(`@/assets/img/${img}`);
        }
    }
};